import React, { useRef } from "react";
import slider1 from "../../../Images/slider1.webp";
import slider2 from "../../../Images/slider2.webp";
import slider3 from "../../../Images/slider3.webp";
import slider4 from "../../../Images/slider4.webp";

const featureCards = [
  {
    id: 1,
    title: "Quick Approval",
    description:
      "Get loan approval in as little as 24 hours with our streamlined digital process.",
    icon: slider1,
  },
  {
    id: 2,
    title: "Secure & Safe",
    description:
      "Bank-level security with 256-bit encryption to protect your personal information.",
    icon: slider2,
  },
  {
    id: 3,
    title: "Mobile First",
    description:
      "Apply, track, and manage your loan entirely from your smartphone.",
    icon: slider3,
  },
  {
    id: 4,
    title: "No Hidden Fees",
    description:
      "Transparent pricing with no processing fees or hidden charges.",
    icon: slider4,
  },
];

const MmbFeatureCarousel = () => {
  const scrollRef = useRef(null);

  const scrollByCards = (direction = "right") => {
    const container = scrollRef.current;
    if (!container) return;

    const card = container.querySelector(".mmb-feature-card");
    const cardWidth = card ? card.offsetWidth + 24 : 280;
    const delta = direction === "right" ? cardWidth : -cardWidth;

    container.scrollBy({
      left: delta,
      behavior: "smooth",
    });
  };

  return (
    <section className="mmb-feature-carousel">
      <div className="mmb-feature-carousel-header"></div>

      <div className="mmb-feature-carousel-track" ref={scrollRef}>
        {featureCards.map((card) => (
          <article key={card.id} className="mmb-feature-card">
            <div className="mmb-feature-card-icon-wrapper">
              <div className="mmb-feature-card-icon">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="mmb-feature-card-img"
                />
              </div>
            </div>

            <h3 className="mmb-feature-card-title">{card.title}</h3>
            <p className="mmb-feature-card-description">{card.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default MmbFeatureCarousel;
